import { createFileRoute } from "@tanstack/react-router";
import { BillScreen } from "../features/bill/bill-screen";
import { Require } from "../features/require";

/** An order's bill screen (P4-T16), beside the board on wide screens like the order. */
export const Route = createFileRoute("/orders/$orderId_/bill")({ component: Page });

function Page() {
	const { orderId } = Route.useParams();
	return (
		<Require permission="bill.create">
			<BillScreen key={orderId} orderId={orderId} />
		</Require>
	);
}
